"use strict";Object.defineProperty(exports, "__esModule", {value: true}); const MAX_NAME_LENGTH = 100; exports.MAX_NAME_LENGTH = MAX_NAME_LENGTH
